const people = [
    {
      name: 'Leslie Alexander',
      event_det: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci sint magni alias non molestiae perferendis',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },
    {
      name: 'Leslie Alexander',
      event_det: 'leslie.alexander@example.com',
      date:"12.02.2025"
    },

  ]
  
  export default function Events() {
    return (
      <ul role="list" className="divide-y divide-gray-100">
        {people.map((person) => (
          <li key={person.name} className="flex  justify-between gap-x-52 py-5">
            <div className="flex flex-wrap min-w-0 gap-x-2">
              <div className="min-w-0 flex max-w-52 flex-wrap">
                <p className="text-sm/6 font-semibold text-gray-900">{person.name}</p>
                <p className="text-sm/6 font-semibold text-gray-900">{person.event_det}</p>
                <button  className="tab-open-btns">Read more</button>
              </div>
            </div>
            <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
              <p>{person.date}</p>
            </div>
          </li>
        ))}
      </ul>
    )
  }
  